import Grid from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

import ButtonComponent from '#app/Component/ButtonComponent';
import MultipleSelectComponent from '#app/Component/MultipleSelectComponent';
import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import { Filters } from '#app/View/ClientService/OrderClientLitigeList';
import useCarriers from '#app/hooks/useCarriers';
import { ChannelSelects } from '#app/typings/channel';
import { OrderClientStateSelects } from '#app/typings/orderClient';
import { DisputeStateSelects, DisputeTypeSelects } from '#app/typings/orderClientLitige';

type Props = {
  filters: Filters;
  handleSearch: (data: Filters) => void;
};

const Search: React.FC<Props> = ({ filters, handleSearch }) => {
  const classes = useStyles();
  const { carriers } = useCarriers();

  const [formSearch, setFormSearch] = useState<Form>({
    number: {
      name: 'number',
      label: 'Référence',
      textHelper: 'Rechercher par référence.',
      type: 'text',
      defaultValue: filters?.number,
    },
    email: {
      name: 'email',
      label: 'Email',
      textHelper: 'Rechercher par email.',
      type: 'text',
      defaultValue: filters?.email,
    },
    name: {
      name: 'name',
      label: 'Client',
      textHelper: 'Rechercher par client.',
      type: 'text',
      defaultValue: filters?.name,
    },
    channels: {
      name: 'channels',
      label: 'Canal',
      textHelper: 'Rechercher par canaux.',
      type: 'array',
      defaultValue: filters?.channels,
    },
    orderClientStates: {
      name: 'orderClientStates',
      label: 'État de la commande',
      textHelper: 'Rechercher par état.',
      type: 'array',
      defaultValue: filters?.orderClientStates,
    },
    types: {
      name: 'types',
      label: 'Type litige',
      textHelper: 'Rechercher par type de litige.',
      type: 'array',
      defaultValue: filters?.types,
    },
    states: {
      name: 'states',
      label: 'État litige',
      textHelper: 'Rechercher par état de litige.',
      type: 'array',
      defaultValue: filters?.states,
    },
    carriers: {
      name: 'carriers',
      label: 'Transporteur',
      textHelper: 'Rechercher par transporteur.',
      type: 'array',
      defaultValue: filters?.carriers,
    },
  });

  const handlerFormSearch = initFormHandler(formSearch, setFormSearch);
  useEffect(() => {
    handlerFormSearch.start();
  }, []);

  const getData = (): Omit<Filters, 'page' | 'limit'> => {
    const data = handlerFormSearch.getData();

    return {
      states: data.states,
      types: data.types,
      channels: data.channels,
      orderClientStates: data.orderClientStates,
      carriers: data.carriers,
      number: data.number,
      email: data.email,
      name: data.name,
    };
  };

  return (
    <ShadowBoxComponent>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="number" handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="email" handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="name" handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent withSelectAll id="carriers" options={carriers} handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent withSelectAll id="channels" options={ChannelSelects} handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent
            withSelectAll
            id="orderClientStates"
            options={OrderClientStateSelects}
            handler={handlerFormSearch}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent
            withSelectAll
            id="states"
            options={DisputeStateSelects}
            handler={handlerFormSearch}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent withSelectAll id="types" options={DisputeTypeSelects} handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <ButtonComponent className={classes.button} label="Rechercher" onClick={() => handleSearch(getData())} />
        </Grid>
      </Grid>
    </ShadowBoxComponent>
  );
};

const useStyles = makeStyles({
  button: {
    margin: '6px !important',
  },
});

export default Search;
